module.exports = __webpack_public_path__ + "img/multiterminal.37b934b5.png";